import styled from '@emotion/styled';
import { ITheme, Responsive } from '../../../ui';
import SecurityCard from './SecurityCard';
import { findSecurityPoiId } from '../domain/utils/findSecurityPoiId';
import { IPoiItem } from '../../shop-dine-relax/domain/models/IPoiItem';
import { ISecurityCheckpoint } from '../domain/models/ISecurityCheckpoint';

interface ICheckpointsListProps {
	checkpoints?: ISecurityCheckpoint[];
	securityPoiData?: IPoiItem[];
}

export default function CheckpointsList({
	checkpoints,
	securityPoiData,
}: ICheckpointsListProps) {
	return (
		<InfoCardWrapper>
			{checkpoints?.map((checkpoint: ISecurityCheckpoint) => {
				const poiId =
					securityPoiData && findSecurityPoiId(securityPoiData, checkpoint.id);

				return (
					<SecurityCard
						key={checkpoint.id}
						checkpoint={checkpoint}
						poiId={poiId}
					/>
				);
			})}
		</InfoCardWrapper>
	);
}

export const InfoCardWrapper = styled.div<{}, ITheme>`
	display: grid;
	grid-template-columns: 1fr 1fr;
	grid-gap: ${(props) => props.theme.grid.gutter.horizontal.default};
	align-items: start;

	@media (${Responsive.getMediaQueryForBreakpoint('mobileXL')}) {
		display: flex;
		flex-direction: column;
		align-items: stretch;
	}
`;
